import { Loader } from 'shared';

type LoadingWrapperProps = {
  children: React.ReactNode;
  isLoading: boolean;
};

export const LoadingWrapper = ({
  children,
  isLoading,
}: LoadingWrapperProps) => <>{isLoading ? <Loader /> : children}</>;
